import type { FilterSystemVariableId } from 'lib-shared-types-api';

export function getVariableName(id: FilterSystemVariableId): string {
  switch (id) {
    case 'body':
      return 'Body';
    case 'caller_number':
      return 'Caller number';
    case 'cc_emails':
      return 'CC emails';
    case 'channel':
      return 'Channel';
    case 'csid':
      return 'Conversation ID';
    case 'date':
      return 'Date';
    case 'date_range':
      return 'Date range';
    case 'direction':
      return 'Direction';
    case 'from_email':
      return 'From email';
    case 'from_name':
      return 'From name';
    case 'language':
      return 'Language';
    case 'receiving_number':
      return 'Receiving number';
    case 'subject':
      return 'Subject';
    case 'subject_or_body':
      return 'Subject or body';
    case 'to_email':
      return 'To email';
    default:
      return id;
  }
}
